<div class="layout-bookmarks">
  <ebw-monorepo-sidebar-header [icon]="'bookmarks'" [title]="'map.sidebar.bookmark.my_views'" [isSvg]="false">
    {{ 'map.sidebar.bookmark.info_section' | translate }}
  </ebw-monorepo-sidebar-header>
  <div class="d-flex flex-column">
    <div class="py-2">
      <button mat-flat-button color="primary" class="w-100 add-layer-btn" (click)="managerViewGo()">
        <mat-icon class="me-2">add</mat-icon>
        <span>{{ 'map.sidebar.bookmark.new_views' | translate }}</span>
      </button>
    </div>

    <!-- Ricerca bookmarks -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label class="bold">{{ 'map.sidebar.bookmark.search' | translate }}</mat-label>
      <input matInput type="text" class="form-control" [(ngModel)]="ricerca" (keyup)="filterBookmarks(ricerca)" />
    </mat-form-field>
  </div>

  <div class="list-scroll">
    <!-- Messaggio no bookmark -->
    <div class="row g-0" *ngIf="bookmarks.length == 0">
      <div class="col py-3 px-2">
        {{ 'common.no_result' | translate }}
      </div>
    </div>

    <!-- Lista bookmarks -->
    <div
      *ngFor="let book of bookmarks; let i = index"
      class="p-3 list-card"
      [ngClass]="{ favourite_template: book.isFavourite }"
      [title]="book.name"
    >
      <div class="d-flex flex-column gap-2 overflow-hidden w-100">
        <div class="d-flex align-items-center justify-content-start gap-2">
          <ng-container *ngIf="!(book.user_id != currentUserId || !this.flagPermessoVisibilityBookmark)">
            <mat-icon [matTooltip]="'map.sidebar.bookmark.set_public' | translate" *ngIf="book.user_id == null">
              lock_open
            </mat-icon>
            <mat-icon [matTooltip]="'map.sidebar.bookmark.set_private' | translate" *ngIf="book.user_id != null">
              lock
            </mat-icon>
          </ng-container>

          <div class="list-card-label">
            {{ book.name }}
          </div>
        </div>
        <div class="list-card-desc" [matTooltip]="book.description">
          {{ book.description }}
        </div>
      </div>

      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item class="w-100" (click)="positioningOnMap(book.bbox, book.active_layers)">
          <mat-icon class="me-1" color="accent">my_location</mat-icon>
          <span>{{ 'map.sidebar.bookmark.go_to' | translate }}</span>
        </button>
        <ng-container *ngIf="book.user_id == currentUserId || !book.user_id">
          <button mat-menu-item class="w-100" (click)="managerViewGo(book)">
            <mat-icon class="me-1" color="accent">edit</mat-icon>
            <span>{{ 'common.modify' | translate }}</span>
          </button>
          <button mat-menu-item class="w-100" (click)="setOrUnsetAsFavourite(book, true)" *ngIf="!book.isFavourite && !atLeastOneFavorite()">
            <mat-icon class="me-1" color="primary">star</mat-icon>
            <span>{{ 'common.setFavouriteBookmark' | translate }}</span>
          </button>
          <button mat-menu-item class="w-100" (click)="setOrUnsetAsFavourite(book, false)" *ngIf="book.isFavourite">
            <mat-icon class="me-1">star_border</mat-icon>
            <span>{{ 'common.removeFavouriteBookmark' | translate }}</span>
          </button>
          <button mat-menu-item class="w-100" (click)="deleteView(book.id, book.name)">
            <mat-icon class="me-1" color="warn">delete</mat-icon>
            <span>{{ 'common.delete' | translate }}</span>
          </button>
        </ng-container>
      </mat-menu>
    </div>
  </div>

  <mat-paginator
    class="paginator"
    #paginator
    [length]="row"
    [hidePageSize]="true"
    [pageSize]="limit"
    aria-label="Select page"
    (page)="changePage($event)"
    [pageIndex]="pageIndex"
  >
  </mat-paginator>
</div>
